/**
 * Slider
 */

export default function Slider() {
    const selectors = {
        'slider': '.js-slider',
    };

    this.init = () => {
        this.slider();

        function handleSlide() {
            if (window.innerWidth > 768) {
                if (!jQuery('.ecosystem-video .slider').hasClass('slick-initialized')) {
                    jQuery('.ecosystem-video .slider').slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        autoplay: false,
                        infinite: false,
                        adaptiveHeight: true,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    })
                }
                const slider = document.querySelector('.ecosystem-video .slider');
                if (slider){
                    const thumbItem = slider.querySelector('.item .thumbnail');
                    slider.style.setProperty('--heightThumb', thumbItem ? thumbItem.clientHeight + "px" : "");
                }

            } else {
                if (jQuery('.ecosystem-video .slider').hasClass('slick-initialized')) {
                    jQuery('.ecosystem-video .slider').slick('unslick');
                }
            }
        }
        handleSlide();
        jQuery(window).resize(function (e) {
            handleSlide();
        });
    };

    this.slider = () => {
        window.innerWidth = document.documentElement.clientWidth;

        jQuery(selectors.slider).each((index, item) => {

            let $this = jQuery(item);

            $this.slick($this.data('slick'));
        })
    }

}
